import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-width":"250px"} }

import {
  UploaderComponent,
  AsyncSettingsModel,
  UploadingEventArgs,
  RemovingEventArgs,
  FileInfo
} from "@syncfusion/ej2-vue-inputs";
import {reactive, ref, watch} from "vue";
import {Api} from "@/shared/services/api";
import {TempFileInfo} from "@/shared/model/TempFileInfo";

interface Props {
  modelValue?: TempFileInfo[]
  multiple?: boolean
  allowedExtensions?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogUploader',
  props: {
    modelValue: { default: undefined },
    multiple: { type: Boolean, default: true },
    allowedExtensions: { default: undefined }
  },
  emits: ["change", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const _uploader = ref<InstanceType<typeof UploaderComponent> | null>(null)


const _emit = __emit;


const _asyncSettings = reactive<AsyncSettingsModel>({
  saveUrl: Api.uploaderSaveUrl(),
  removeUrl: Api.uploaderRemoveUrl()
});

const _files = reactive<FileInfo[]>([])

watch(props, () => {
    /*
      const path = props.api?.uploaderPath();
      _asyncSettings.removeUrl = path?.removeUrl
      _asyncSettings.saveUrl = path?.saveUrl
    */
  },
  {immediate: true})

function onUploading(args: UploadingEventArgs) {
  if (!Api.token)
    return
  args.currentRequest?.setRequestHeader("Authorization", "Bearer " + Api.token)
}

function onRemoving(args: RemovingEventArgs) {
  if (!Api.token)
    return
  args.postRawFile = false
  args.currentRequest?.setRequestHeader("Authorization", "Bearer " + Api.token)
}


function onSuccess(args: any) {
  console.log(args)
  const headers: string[] = args.response.headers.split('\r\n')

  const idHeader = headers.find(e => {
    return e.startsWith('id')
  })
  if (idHeader) {
    const id = idHeader.split(':')[1].trim()
    args.file.id = id
    //args.file.name = id
  }

  if (args.operation === "upload") {
    if (!props.multiple && _files.length === 1) {
      _uploader.value?.remove(_files[0])
    }

    _files.push(args.file)
  } else if (args.operation === "remove") {
    const array = _files.filter((t) => t.name !== args.file.name)


    _files.length = 0;
    array?.forEach((file: any) => {
      _files.push(file)
    })
  }
}

function onChange() {

  const result: TempFileInfo[] = []
  _files.map(t => {
    result.push({id: t.id ?? "", fileName: t.name})
  })

  _emit("update:modelValue", result)
  _emit("change")

  /*
    if (args.file) { this.change(args.file) }
    if (args.files) { this.change(args.files) }
  */
}

function clear() {
  _uploader.value?.remove()
}

__expose({
  clear
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UploaderComponent), {
      ref_key: "_uploader",
      ref: _uploader,
      "async-settings": _asyncSettings,
      uploading: onUploading,
      removing: onRemoving,
      success: onSuccess,
      change: onChange,
      multiple: __props.multiple,
      "max-file-size": "100000000",
      name: "file",
      style: {"min-width":"600px"},
      "allowed-extensions": __props.allowedExtensions
    }, null, 8, ["async-settings", "multiple", "allowed-extensions"])
  ]))
}
}

})